export class InstagramService {
    static $inject = ['ConfigurationsService', 'ProfileCommandProcessor', 'MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(ConfigurationsService, ProfileCommandProcessor, MessagingHubService, MESSAGINGHUBDOMAIN) {
        this.ConfigurationsService = ConfigurationsService;
        this.ProfileCommandProcessor = ProfileCommandProcessor;
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.POSTMASTER_INSTAGRAM_GATEWAY = 'postmaster@instagram.gw';
        this.INSTAGRAM_BUSINESS_ACCOUNT_ENTRYPOINT = '/instagram_business_account';
        this.INSTAGRAM_ACCOUNT_PROFILE_CONNECTED = '/instagram-account-profile-connected';
        this.INSTAGRAM_ICE_BREAKER = '/ice-breaker';
        this.INSTAGRAM_EMAILS = '/notification-emails';
        this.getEntryPointsConfigurationsAsync = async () => {
            const commandResponse = await this.MessagingHubService.processCommand({
                to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
                method: 'get',
                uri: '/entry-point',
            });
            const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
            return resource;
        };
        this.setEntryPointsConfigurationsAsync = async (entryPointConfigurations) => {
            const commandResponse = await this.MessagingHubService.processCommand({
                to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
                method: 'set',
                uri: '/entry-point',
                type: 'application/json',
                resource: { ...entryPointConfigurations },
            });
            const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
            return resource;
        };
    }
    setConfiguration(configuration, useConfigurationsApplication = false) {
        return this.ConfigurationsService.set(`${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`, configuration, undefined, useConfigurationsApplication);
    }
    validateApplicationInfo(applicationInfo) {
        return this.MessagingHubService.sendCommand({
            method: 'set',
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/validate-app',
            type: 'application/vnd.iris.facebook.application+json',
            resource: { ...applicationInfo },
        });
    }
    //WhitelistedDomains
    savewhiteListedDomains(application, whiteListedDomains) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'set', 'whitelisted-domains', 'application/vnd.lime.collection+json', {
            itemType: 'application/vnd.lime.web-link+json',
            items: whiteListedDomains,
        });
    }
    getwhiteListedDomains(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'get', 'whitelisted-domains');
    }
    deletewhiteListedDomains(application) {
        return this.ProfileCommandProcessor.sendProfileCommand(application, 'delete', 'whitelisted-domains');
    }
    async getInstagramBusinessAccountAsync(accessToken) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `${this.INSTAGRAM_BUSINESS_ACCOUNT_ENTRYPOINT}/${accessToken}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getInstagramAccountProfileConnectedAsync() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `${this.INSTAGRAM_ACCOUNT_PROFILE_CONNECTED}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async setStateConfigurationAsync(configurations) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            uri: '/state-configurations',
            type: 'application/json',
            resource: configurations,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async setIceBreakerAsync(questions) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            uri: `${this.INSTAGRAM_ICE_BREAKER}`,
            type: 'application/vnd.iris.ice-breaker+json',
            resource: {
                'questions': questions,
            },
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async deleteIceBreakerAsync() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'delete',
            uri: `${this.INSTAGRAM_ICE_BREAKER}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getIceBreakerAsync() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `${this.INSTAGRAM_ICE_BREAKER}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async setEmailsAsync(emails) {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            uri: `${this.INSTAGRAM_EMAILS}`,
            type: 'application/vnd.iris.notification-emails+json',
            resource: {
                'emails': emails,
            },
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
    async getEmailsAsync() {
        const commandResponse = await this.MessagingHubService.processCommand({
            to: `${this.POSTMASTER_INSTAGRAM_GATEWAY}.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `${this.INSTAGRAM_EMAILS}`,
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource.emails;
    }
}
InstagramService.$inject = ['ConfigurationsService', 'ProfileCommandProcessor', 'MessagingHubService', 'MESSAGINGHUBDOMAIN'];
